import { Plugin } from 'vue';
import { STORE_ID, useAuthStore } from '~app/core/auth/store';
import { Pinia } from 'pinia';
import { Router } from 'vue-router';
import { authGuard } from '~app/core/auth/guards';
import { ssoRedirectCallbackRoute } from '~app/core/auth/routes';
import { apiClient, ApiClient } from '~app/core/api-client';
import { authErrorHandlerInterceptor, tokenHeaderInterceptor } from '~app/core/auth/interceptors';
import { storage } from '~app/shared/storage';
import { isNullOrUndefined } from '~app/shared/json-mapper/utils';

export type AuthPluginOptions = {
  pinia: Pinia;
  router: Router;
  apiClient: ApiClient;
};

export const createAuthPlugin = ({ pinia, router }: AuthPluginOptions): Plugin<void> => {
  return {
    install() {
      const authStore = useAuthStore(pinia);

      apiClient.interceptors.request.use(tokenHeaderInterceptor);
      apiClient.interceptors.response.use((response) => response, authErrorHandlerInterceptor);

      router.addRoute(ssoRedirectCallbackRoute);
      router.beforeEach(authGuard);

      // Consider creating a pinia plugin
      const authStoreCache = storage.load(STORE_ID);
      authStore.$patch(authStoreCache);
      authStore.$subscribe((mutation, state) => storage.save(STORE_ID, { token: state.token }));

      window.addEventListener('focus', () => {
        const authStoreCache = storage.load(STORE_ID);
        const accessToken = authStore?.token?.accessToken;
        const accessTokenCached = authStoreCache?.token?.accessToken;

        if (
          !isNullOrUndefined(accessToken) &&
          !isNullOrUndefined(accessTokenCached) &&
          accessToken !== accessTokenCached
        ) {
          authStore.$patch(authStoreCache);
          authStore.fetchUser();
        }
      });
    },
  };
};
